import React from 'react';

export const EditInformationBlock = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="24" height="24" rx="4" fill="#EAEBED" />
            <path
                d="M13.4285 6.18622C12.9572 6.23318 12.504 6.46305 12.1747 6.86532L5.76436 14.6942L5.75023 14.8377L5.50447 17.3631L5.46358 17.7322C5.44763 17.8761 5.58521 17.9888 5.72317 17.9447L6.07694 17.8318L8.50425 17.0927L8.64215 17.0505L15.0525 9.22168C15.7112 8.41713 15.5963 7.26337 14.7917 6.6046C14.3895 6.27522 13.8999 6.13926 13.4285 6.18622ZM13.514 7.04451C13.7409 7.0219 13.9799 7.1029 14.2217 7.30084C14.7032 7.69515 14.7505 8.17002 14.3562 8.65159L14.0634 8.99338L12.5936 7.78986L12.8709 7.43541C13.0689 7.19366 13.2872 7.06711 13.514 7.04451ZM12.0235 8.4861L13.4934 9.68962L8.59061 15.6773C8.23766 15.1298 7.72708 14.7118 7.12076 14.4738L12.0235 8.4861ZM6.61677 15.2629C7.17845 15.4272 7.64454 15.8088 7.91642 16.3271L6.46847 16.7697L6.61677 15.2629Z"
                fill="#757575"
            />
            <path
                d="M10 17.5C10 17.2239 10.2239 17 10.5 17H17.5C17.7761 17 18 17.2239 18 17.5C18 17.7761 17.7761 18 17.5 18H10.5C10.2239 18 10 17.7761 10 17.5Z"
                fill="#757575"
            />
        </svg>
    );
};
